import * as React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IPaymentModel } from 'interfaces/IPaymentModel';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import CreditCardForm from './CreditCardForm';
import { paymentService } from 'services/PaymentService';
import Translate from 'components/Translate';
import { cartService } from 'services/CartService';
import { enPaymentType } from 'enums/enPaymentType';

interface IState extends IStateBase<IPaymentModel> {
  model: IPaymentModel;
  paymentType: enPaymentType;
}

interface IProps {
  index: number;
}

export default class PaymentForm extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.bindModel(paymentService.getPayment(this.props.index));
    cartService
      .getCart()
      .bindComponent(this)
      .subscribe(cart => this.setState({ paymentType: cart.config.paymentType }));
  }

  render() {
    if (!this.state) {
      return <div />;
    }

    const { model, paymentType } = this.state;

    return (
      <div>
        {[enPaymentMethod.PAYPAL, enPaymentMethod.BOLETO].indexOf(model.paymentMethod) >= 0 ? (
          [enPaymentMethod.PAYPAL].indexOf(model.paymentMethod) >= 0 ? (
            <span className="chk-paymentForm__paypalMessage">
              <p>
                <Translate term="Você será redirecionado para o Paypal para concluir o pagamento." />
              </p>
              <p>
                <Translate term="Pagamentos via Paypal somente à vista." />
              </p>
            </span>
          ) : (
            <div className="chk-paymentForm__boletoMessage">
              {paymentType !== enPaymentType.SUBSCRIPTION ? (
                <p>
                  <Translate term="Boleto somente em uma parcela." />
                </p>
              ) : null}
              <p>
                <Translate term="Pagamentos com Boleto Bancário levam até 3 dias úteis para serem compensados e então terem os produtos liberados." />
              </p>
              <p>
                <Translate
                  // tslint:disable-next-line:max-line-length
                  term="Depois do pagamento, fique atento ao seu e-mail para receber os dados de acesso ao produto (verifique também a caixa de SPAM)."
                />
              </p>
            </div>
          )
        ) : (
          <CreditCardForm index={this.props.index} />
        )}
      </div>
    );
  }
}
